import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-tt-verified-page',
  templateUrl: './about-tt-verified-page.component.html',
  styleUrls: ['./about-tt-verified-page.component.scss']
})
export class AboutTtVerifiedPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
